import AgenciaUpdate from './AgenciaUpdate'
export {AgenciaUpdate}
export default AgenciaUpdate
